import { render, staticRenderFns } from "./MessageBoard.vue?vue&type=template&id=3223ce70&scoped=true&"
import script from "./MessageBoard.vue?vue&type=script&lang=js&"
export * from "./MessageBoard.vue?vue&type=script&lang=js&"
import style0 from "./MessageBoard.vue?vue&type=style&index=0&id=3223ce70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223ce70",
  null
  
)

export default component.exports